import GpanelContactsSyncPage from '../gpanel-contacts-sync.tsx';
import { useAllSyncsQuery } from '../../../gpanel-contacts-queries.ts';

export default function GpanelContactsAllSyncs() {
  const query = useAllSyncsQuery();
  return <GpanelContactsSyncPage title="Contact Syncs" query={query} />;
}
